import React from 'react'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import { Col, Image, Row, Table } from 'react-bootstrap'
import { useLocation } from 'react-router-dom'

export default function FRPlywood() {
    let image = useLocation().state.image

    return (
        <div>
            <Row className='mx-0' style={{ marginBottom: '61px' }}>
                <Col md={{ order: 'last' }} className='position-relative w-100 col-md-6 col-12 product-page-image-section mt-5 mt-md-0'>
                    <Image className='product-page-image position-absolute ' src={image} />
                </Col>
                <Col md={{ order: 'first' }} className='col-md-6 col-12'>
                    <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                        <h3 style={{ fontWeight: '800', color: '#FCCD37', textAlign: 'start' }} className='mb-4'>ABOUT THE<br /> PRODUCT</h3>
                    </AnimationOnScroll>
                    <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                        <p align='left' style={{ fontSize: '1.3em' }}>
                            The Fire retardant plywood is composed with high density hardwood veneers that are treated
                            with fire retardant chemicals during the manufacturing process.
                            <br /><br />
                            Fire-retardant plywood prices are slightly higher than normal MR plywood.
                            <br /><br />
                            Want to know why?<br />
                            Well, this is so because it undergoes a chemical treatment that helps it defer flames and delay
                            ignition. Make no mistake, it is not fireproof, only fire retardant.
                            <br /><br />
                            The plywood is especially useful in areas like the kitchen, cinema theatres, and closed spaces,
                            etc. whereof a fire. It is incredibly useful because upon ignition; it does not emit harmful
                            emissions that can cause breathing difficulty, which helps protect us from fainting, saving us.
                            <br /><br />
                            Manufacturers make fire retardant plywood with high-density hardwood veneers by treating these
                            individual veneers with fire-retardant chemicals during the manufacturing process.
                            <br /><br />
                            Who checks if these are “really fire-retardant”?<br />
                            The Bureau of Indian Standards checks for the safety standard of these plies before they may
                            manufacture these plies on a large scale.
                        </p>
                    </AnimationOnScroll>
                </Col>
            </Row>
            <Row>
                <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                    <h3 style={{ fontWeight: '800', color: '#FCCD37', textAlign: 'start' }} className='mb-4'>Want to know the best part?</h3>
                </AnimationOnScroll>
                <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                    <p align='left' style={{ fontSize: '1.3em' }}>
                        Imagine that the ply caught fire once…. the ply will still have some fire-retarding properties that allows
                        it to delay the second ignition where the time to ignite will not be less than 15t/6min where “t” is the
                        thickness of the fire-retardant plywood.
                        <br /><br />
                        The next time you complain about Fire-retardant plywood prices, remember a few bucks here can save your
                        life later!
                        <br /><br />
                        This treatment makes the plies resistant to extreme fire conditions. They are designed to resist sparks,
                        ignite without any penetration and lower the pace of smoke generation in case of a fire. Any chance of leak
                        and spread of fire is also reduced by these fire-retardant plies. They undergo various tests to check
                        regularities like flammability, rate of burning and flames to penetrate the plywood, etc as per the Bureau
                        of India Standards.
                        <br /><br />
                        Fire retardant plies are advisable to be used in areas where there is a regular use of fire and heat,
                        making it ideal for the kitchen and cooking areas. Using them in public places like cinema halls, shopping
                        malls, restaurants etc ensures safety of the property if there is an accidental fire. It is good to use
                        these plies in train compartments, bus coaches, ships etc as it is instrumental in reducing electrical
                        fires. The safety factor makes it a good choice for using it in interiors of home and office.
                    </p>
                </AnimationOnScroll>
            </Row>
            <Row className='mx-0 justify-content-between' style={{ marginTop: '109px' }}>
                <Col md={2} className='d-flex align-items-center'>
                    <h3 style={{ fontWeight: '800', color: '#FCCD37', textAlign: 'start' }}>Product Specification</h3></Col>
                <Col md={9}>
                    <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                        <Table responsive>
                            <thead style={{ color: '#FFF' }}>
                                <tr>
                                    <th className='text-start'>TEST</th>
                                    <th className='text-start'>ISI SPECIFIED VALUE</th>
                                    <th className='text-start'>RESULT OBTAINED</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontWeight: '500' }}>
                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Moisture content</td>
                                    <td className='text-start'>150mm x 75mm</td>
                                    <td className='text-start'>Max 20%</td>
                                </tr>

                                <tr style={{ backgroundColor: '#FFC700' }}>
                                    <td className='text-start'>Flammability</td>
                                    <td className='text-start'>125mm x 125mm</td>
                                    <td className='text-start'>Time taken for the second ignition shall not be<br/> less than 30min.</td>
                                </tr>

                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Flame penetration</td>
                                    <td className='text-start'>125mm x 125mm</td>
                                    <td className='text-start'>Time taken for flame penetration shall not be<br/>
                                        less than 15t/6 min, where ‘t’ is the thickness<br/>
                                        of plywood</td>
                                </tr>

                                <tr style={{ backgroundColor: '#FFC700' }}>
                                    <td className='text-start'>Rate of burning</td>
                                    <td className='text-start'>100mm x 1.25mm</td>
                                    <td className='text-start'>Time taken to lose weight from 30% to 70%<br/>
                                        shall not be less than 20min.</td>
                                </tr>

                            </tbody>
                        </Table>
                    </AnimationOnScroll>
                </Col>
            </Row>
        </div>
    )
}
